import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface Props {
  open: boolean;
  title: string;
  content: string;
  confirmButtonLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationDialog = ({
  open,
  title,
  content,
  confirmButtonLabel = "Confirm",
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 1,
          minWidth: 300,
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ textAlign: "center" }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: "none", color: "grey.600" }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          variant="contained"
          color="primary"
          sx={{ textTransform: "none", borderRadius: 2, paddingX: 3 }}
        >
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
